import { api } from '..';
import { ShippingCosts, ShippingCost } from './types';

export const shippingCostApi = api.enhanceEndpoints({ addTagTypes: ['ShippingCost'] }).injectEndpoints({
  endpoints: build => ({
    getShippingCostList: build.query<ShippingCosts, { offset: number; limit: number; or: boolean; filter: string }>({
      query: ({ offset, limit, or, filter }) => ({
        url: `v1/shipping-cost?offset=${offset || 0}${limit !== undefined ? `&limit=${limit}` : ''
          }${or ? `&or=${or}` : ''}${filter || ''}`,
        method: 'GET',
      }),
    }),
    getShippingCost: build.query<ShippingCost, { id: number }>({
      query: ({ id }) => ({
        url: `v1/shipping-cost/${id}`,
        method: 'GET',
      }),
    }),
    createShippingCost: build.mutation<any, any>({
      query: body => ({
        url: `v1/shipping-cost`,
        method: 'POST',
        body: body,
      }),
    }),
    updateShippingCost: build.mutation<any, any>({
      query: body => ({
        url: `v1/shipping-cost/${body.id}`,
        method: 'PUT',
        body: body.shippingCost,
      }),
    }),
    bulkIsAvailable: build.mutation<any, any>({
      query: body => ({
        url: `v1/shipping-cost/bulk-is-available`,
        method: 'POST',
        body: body,
      }),
    }),
    patchIsAvailable: build.mutation<any, any>({
      query: body => ({
        url: `v1/shipping-cost/${body.id}/is-available`,
        method: 'PUT',
        body: body,
      }),
    }),
    deleteShippingCost: build.mutation<void, { id: number }>({
      query: ({ id }) => ({
        url: `v1/shipping-cost/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useLazyGetShippingCostListQuery,
  useLazyGetShippingCostQuery,
  useCreateShippingCostMutation,
  useUpdateShippingCostMutation,
  useDeleteShippingCostMutation,
  useBulkIsAvailableMutation,
  usePatchIsAvailableMutation,
} = shippingCostApi;
